import React, {useEffect, useState} from 'react';
import CompareReportOptionsForm from "./options/CompareReportOptionsForm";
import DownloadButton from "../../components/reports/DownloadButton";
import DataTable from "../../components/reports/DataTable";
import OutletIcon from "@mui/icons-material/Outlet";
import FooterTotals from "./components/FooterTotals";
import {Grid, Typography, Box} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import "@fontsource/roboto";
import {format} from 'date-fns';

const RIX_ENGINE_COMPARE_COLUMN_LABELS = {
    entity_id: 'Rix ID',
    entity_name: 'Name',
    os: 'OS',
    ad_domain: 'Ad Domain',
    ad_format: 'Ad Format',
    ad_size: 'Ad Size',
    country: 'Country',
    server_region: 'Server Region',
    buyer_net_revenue1: 'Advertiser Net Revenue',
    buyer_net_revenue2: 'Advertiser Net Revenue 2',
    buyer_net_revenue_per: 'Advertiser Net Revenue %',
    seller_net_revenue1: 'Publisher Net Revenue',
    seller_net_revenue2: 'Publisher Net Revenue 2',
    seller_net_revenue_per: 'Publisher Net Revenue %',
    impressions1: 'Impressions',
    impressions2: 'Impressions 2',
    impressions_per: 'Impressions %',
    bid_floor1: 'Bid Floor',
    bid_floor2: 'Bid Floor 2',
    bid_floor_per: 'Bid Floor %',
    fill_rate1: 'Fill Rate %',
    fill_rate2: 'Fill Rate 2 %',
    fill_rate_per: 'Fill Rate %',
    rcpm1: 'rCPM',
    rcpm2: 'rCPM 2',
    rcpm_per: 'rCPM %',
    profit_rate1: 'Profit Rate %',
    profit_rate2: 'Profit Rate 2 %',
    profit_rate_per: 'Profit Rate %',
    win_rate1: 'Win Rate %',
    win_rate2: 'Win Rate 2 %',
    win_rate_per: 'Win Rate %',
    rcpm_rate_per: 'rCPM Rate %',
};

const CompareReport = () => {

    const [data, setData] = useState([]);
    const [name, setName] = useState('');
    const [totals, setTotals] = useState(null);

    useEffect(() => {
        const currentDate = new Date();
        const formattedDate = format(currentDate, 'yyyy-MM-dd');
        setName(`RixEngine CompareReport - ${formattedDate}`);
    }, [data]);

    return (
        <div>
            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      paddingTop: 0,
                      marginLeft: '-10px',
                      marginTop: '-5px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: "100%"}}>
                    <Accordion sx={{width: "100%"}}>
                        <AccordionSummary
                            expandIcon={<InfoOutlinedIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{
                                backgroundColor: '#f0f3f5',
                                width: "100%",
                                height: '35px !important',
                                minHeight: '25px !important',
                            }}
                        >
                            Explanations
                        </AccordionSummary>
                        <AccordionDetails sx={{width: "100%"}}>
                            <Box>
                                <Typography variant="subtitle1" sx={{marginBottom: '1rem'}}>
                                    📊 RixEngine Compare Report – options and functionality
                                </Typography>

                                <Typography variant="subtitle1" sx={{marginBottom: '0.5rem'}}>
                                    ⚙️ Entity selection
                                </Typography>
                                <Typography variant="body1" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>
                                    Select the data entities to include in the report using the provided options.
                                </Typography>

                                <Typography variant="subtitle1" sx={{marginBottom: '0.5rem'}}>
                                    📈 Statistics selection
                                </Typography>
                                <Typography variant="body1" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>
                                    Choose which statistics to include in the compare report.
                                </Typography>

                                <Typography variant="subtitle1" sx={{marginBottom: '0.5rem'}}>
                                    📅 Date range
                                </Typography>
                                <Typography variant="body1" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>
                                    Set Period I and Period II using the date range selectors.
                                </Typography>

                                <Typography variant="subtitle1" sx={{marginBottom: '0.5rem'}}>
                                    🚀 Generate report
                                </Typography>
                                <Typography variant="body1" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>
                                    Click "Generate Report" to load data for the selected options and date ranges.
                                </Typography>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>

            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      marginLeft: '-10px',
                      marginTop: '20px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: "100%"}}>
                    <CompareReportOptionsForm onGenerate={setData} onTotalsGet={setTotals}/>
                </Grid>
                <Grid item xs={12} md={12}>
                    {(data.length !== 0 && data !== false) && (
                        <DownloadButton
                            data={data}
                            label={name}
                            sx={{float: 'CompareReport'}}
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={12}>
                    {data === false ? (
                        <Typography variant="h4" component="h2" align="center">
                            <OutletIcon fontSize="large"/> NO DATA
                        </Typography>
                    ) : (
                        <DataTable data={data} columnLabels={RIX_ENGINE_COMPARE_COLUMN_LABELS}/>
                    )}
                    {totals && Object.keys(totals).length > 0 && <FooterTotals totals={totals}/>}
                </Grid>
            </Grid>
        </div>
    );
};

export default CompareReport;
